import {
  Card,
  DayCell,
  DayHeader,
  DayHeaderDay,
  Divider,
  Grid,
  IconRow,
  TempColumn,
  TempFeels,
  TempMain,
  Weekdays,
} from "./styles";
import { CloudIcon } from "../../../shared/ui/icons/cloudIcon";
import { WeatherCalendarMobile } from "./WeatherCalendarMobile/WeatherCalendarMobile.tsx";
import { Day } from "../lib/makeDays.ts";
import { useWeatherStore } from "entities/weather/index.ts";
import { useNavigate } from "react-router-dom";

export type Props = {
  days: Day[];
};

export const WeatherCalendar = ({ days }: Props) => {
  const forecastDays = useWeatherStore((s) => s.forecastDays);

  const data = days.length === 42 ? days : [...days].slice(0, 42);

  const navigate = useNavigate();

  const handleToDays = (dataIso: string) => {
    navigate(`/weather/${dataIso}`);
  };

  const today = new Date();
  const maxDate = new Date();
  maxDate.setDate(today.getDate() + 9);

  return (
    <Card>
      <WeatherCalendarMobile
        days={forecastDays}
        handleToDays={handleToDays}
        today={today}
        maxDate={maxDate}
      />
      <Weekdays>
        <span>пн</span>
        <span>вт</span>
        <span>ср</span>
        <span>чт</span>
        <span>пт</span>
        <span>сб</span>
        <span>вс</span>
      </Weekdays>
      <Divider />
      <Grid>
        {data.map((d, i) => {
          const weekend = d.weekdayIdx === 6 || d.weekdayIdx === 7;
          return (
            <DayCell
              key={i}
              dim={!d.inRange}
              cursor={
                d.date >= today.toISOString().split("T")[0] &&
                d.date <= maxDate.toISOString()
              }
              onClick={() => {
                if (
                  d.inRange &&
                  d.date >= today.toISOString().split("T")[0] &&
                  d.date <= maxDate.toISOString()
                ) {
                  handleToDays(d.date);
                }
              }}
            >
              <DayHeader weekend={weekend}>
                {d.isToday ? (
                  <DayHeaderDay>{d.dayNum}</DayHeaderDay>
                ) : (
                  <span>{d.dayNum}</span>
                )}
              </DayHeader>

              <IconRow>
                <CloudIcon />
                <TempColumn>
                  <TempMain>{d.temp ?? "—"}</TempMain>
                  <TempFeels>{d.feels ?? "—"}</TempFeels>
                </TempColumn>
              </IconRow>
            </DayCell>
          );
        })}
      </Grid>
    </Card>
  );
};
